/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import { Input, InputNumber, Radio } from 'antd';

class RadioButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            value: false,
            feild: {},
        };
        this.inputChange = this.inputChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
    }
    componentDidMount() {
        let { feild_data } = this.props;
        this.setState({ 'feild': feild_data, 'value': feild_data.value })
    }
    componentDidUpdate(prevProps, prevState) {
        let prev_value = prevState.value
        let { feild_data } = this.props;
        if (feild_data.value !== prev_value) {
            this.setState({ 'feild': feild_data, 'value': feild_data.value })
        }
    }
    componentWillUnmount() {
        this.setState({
            date: new Date(),
            error: [],
            value: false,
            feild: {}
        })
    }

    inputChange(evnt) {
        console.log(evnt);
        let { feild_data } = this.props;
        feild_data.colums.map((data, key) => {
            // if (data.name === evnt.target.value) {
            this.setState((state) => ({ 'value': evnt.target.value }), () => {
                this.inputBlur();
            });
            // }
            // else {
            //     this.setState((state) => ({ 'value': null }));
            // }
        })
    }

    inputBlur() {
        let { value, error } = this.state;
        let { feild_data } = this.props;
        feild_data['value'] = value;
        feild_data['error'] = error;
        console.log(feild_data);
        this.props.inputChange(feild_data)
    }

    render() {
        let { feild_data } = this.props;
        let { value } = this.state;
        return (
            <React.Fragment>
                {feild_data.visible &&
                    <div className={`${(feild_data.class && feild_data.class['cols']) ? feild_data.class['cols'] : 'col-12'} form-group  my-auto`}>
                        <label htmlFor={feild_data.name}>{feild_data.title}</label>
                        <div className="row">
                            <div className="col-6 col-md-6">
                                <label htmlFor={feild_data.name}>
                                    <Radio.Group  value={value} disabled={feild_data.disable ? feild_data.disable : false} onChange={this.inputChange} buttonStyle="solid" style={{ marginTop: 16 }}>
                                        {feild_data.colums.map((cdata, ckey) => {
                                            return (
                                                <Radio.Button
                                                    key={ckey}
                                                    // disabled={cdata.disable ? cdata.disable : false}
                                                    value={cdata.name ? cdata.name : null}
                                                    name={cdata.name}>{cdata.title}
                                                </Radio.Button>
                                            )
                                        })}
                                    </Radio.Group>
                                    {/* <Radio.Group disabled={feild_data.disabled ? feild_data.disabled : false} onChange={this.inputChange} >
                                    {feild_data.colums.map((cdata, ckey) => {
                                        return (
                                            <React.Fragment>
                                                <Radio
                                                    key={ckey}
                                                    disabled={cdata.disabled ? cdata.disabled : false}
                                                    value={cdata.name}
                                                    name={cdata.name}
                                                />{cdata.title}
                                            </React.Fragment>
                                        )
                                    })}
                                </Radio.Group> */}
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>}

            </React.Fragment>
        );
    }
}

export default RadioButton;
